import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  anonymousUser: {},
  totalImages: 0,
  images: [],
  videos: [],
  group: {},
};

export const anonymous = createSlice({
  name: "anonymous",
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action.payload,
      };
    },
    setAnonymousUserData(state, action) {
      return {
        ...state,
        anonymousUser: action?.payload,
      };
    },
    setAnonymousUserImages(state, action) {
      return {
        ...state,
        images: action?.payload?.results || [],
        videos: action?.payload?.group?.videos || [],
        anonymousUser: action?.payload?.user || state?.anonymousUser,
        totalImages:
          action?.payload?.totalImages || action?.payload?.results?.length || 0,
      };
    },
    setGroupData(state, action) {
      return {
        ...state,
        group: action.payload,
      };
    },
    clearAnonymousUserData(state) {
      return {
        ...state,
        anonymousUser: {},
        totalImages: 0,
        images: [],
        videos: [],
        group: {},
      };
    },
  },
});

export const {
  setLoading,
  setAnonymousUserData,
  setAnonymousUserImages,
  setGroupData,
  clearAnonymousUserData,
} = anonymous.actions;
export default anonymous.reducer;
